import { useState } from 'react';

import {
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_EQUATION_RESPONSE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_TABLE,
  ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE,
} from 'global/constants';
import {
  ComponentMultipleChoice,
  ComponentEquationResponse,
  ComponentResponse,
  ComponentFillInBlanks,
  ComponentTable,
  ComponentDiscussion,
  ComponentInteractiveResponseSequence,
  ComponentInteractiveResponseCategorise,
  ComponentDraw,
} from '../component.constants';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import {
  MultiViewPage,
  MultiView,
} from 'approot/shared/layout/layout-multi-view';
import {
  QuestionSettingCurrentSubActivity,
  SettingsProps,
} from './activity.constants';
import ActivitySettings from './activity-settings';
import ResponseSettings from '../response/response-settings';
import MultipleChoiceSettings from '../multiple-choice/settings/multiple-choice-settings';
import EquationResponseSettings from '../equation-response/equation-response-settings';
import FillInBlanksSettings from '../fill-in-blanks/settings/fill-in-blanks-settings';
import TableSettings from '../table/table-settings';
import DiscussionSettings from '../discussion/discussion-settings';
import InteractiveResponseSequenceSettings from '../interactive-response/sequence/settings/interactive-response-settings';
import InteractiveResponseCategoriseSettings from '../interactive-response/categorise/settings/interactive-response-categorise-settings';
import DrawSettings from '../draw/settings/draw-settings';

const ActivitySettingsDrawer = (props: SettingsProps) => {
  const { closeDrawer } = useActivityBuilderContext();
  const [subActivity, setSubActivity] =
    useState<QuestionSettingCurrentSubActivity>();

  const component = props.subActivities?.find(s => s.id === subActivity?.id);
  return (
    <MultiView>
      {multiviewProps => (
        <>
          <MultiViewPage
            {...multiviewProps}
            onClose={closeDrawer}
            index={0}
            renderItem={() => (
              <ActivitySettings
                {...props}
                {...multiviewProps}
                onSubActivitySelect={props => {
                  setSubActivity(props);
                }}
              />
            )}
          />
          <MultiViewPage
            {...multiviewProps}
            index={1}
            renderItem={() => (
              <>
                {component?.type ===
                  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_RESPONSE && (
                  <ResponseSettings
                    {...(component as ComponentResponse)}
                    key={component.id}
                    contentId={props.contentId}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
                {component?.type ===
                  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE && (
                  <MultipleChoiceSettings
                    {...(component as ComponentMultipleChoice)}
                    key={component.id}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
                {component?.type ===
                  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_EQUATION_RESPONSE && (
                  <EquationResponseSettings
                    {...(component as ComponentEquationResponse)}
                    key={component.id}
                    contentId={props.contentId}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}

                {component?.type ===
                  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_FILL_IN_BLANKS_RESPONSE && (
                  <FillInBlanksSettings
                    {...(component as ComponentFillInBlanks)}
                    key={component.id}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
                {component?.type === ACTIVITIES_COMPONENT_TYPE_TABLE && (
                  <TableSettings
                    {...(component as ComponentTable)}
                    key={component.id}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
                {component?.type ===
                  ACTIVITIES_COMPONENT_TYPE_DISCUSSION_RESPONSE && (
                  <DiscussionSettings
                    {...(component as ComponentDiscussion)}
                    key={component.id}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
                {component?.type ===
                  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE && (
                  <InteractiveResponseSequenceSettings
                    {...(component as ComponentInteractiveResponseSequence)}
                    key={component.id}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
                {component?.type ===
                  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE && (
                  <InteractiveResponseCategoriseSettings
                    {...(component as ComponentInteractiveResponseCategorise)}
                    key={component.id}
                    contentId={props.contentId}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
                {component?.type === ACTIVITIES_COMPONENT_TYPE_DRAW && (
                  <DrawSettings
                    {...(component as ComponentDraw)}
                    key={component.id}
                    contentId={props.contentId}
                    onCloseChildDrawer={multiviewProps.goBack}
                  />
                )}
              </>
            )}
          />
        </>
      )}
    </MultiView>
  );
};

const ActivitySettingsDrawerWrapper = (props: SettingsProps) => {
  return <ActivitySettingsDrawer {...props} />;
};

export default ActivitySettingsDrawerWrapper;
